import { Pipe, PipeTransform } from '@angular/core';
import { PaymentType } from '../enums';

@Pipe({
    name: 'paymentTypeIcon',
    standalone: true,
    pure: true
})
export class PaymentTypeIconPipe implements PipeTransform {
    transform(value: PaymentType): string {
        switch (value) {
            case PaymentType.Momo:
                return 'icon::momo';
            case PaymentType.ZaloPay:
                return 'icon::zalo-pay';
            case PaymentType.Vnpay:
                return 'icon::vnpay';
            case PaymentType.Payon:
                return 'icon::payon';
            case PaymentType.PosappCard:
                return 'icon::posapp-card';
            case PaymentType.BankTransfer:
            case PaymentType.Cash:
            default:
                return 'icon::money';
        }
    }
}
